module.exports = __webpack_public_path__ + "static/media/IMG_0060.5894a0bf.jpg";